import { render, staticRenderFns } from "./import-item.vue?vue&type=template&id=723a1400&scoped=true"
import script from "./import-item.vue?vue&type=script&lang=js"
export * from "./import-item.vue?vue&type=script&lang=js"
import style0 from "./import-item.vue?vue&type=style&index=0&id=723a1400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723a1400",
  null
  
)

export default component.exports